// @ts-nocheck
import React from 'react';
import { LBButton } from '@linearb/buzz';
import TokenValidator from 'components/TokenValidator/TokenValidator';
import { SensorAuthorization } from 'types/sensorAuthorization';
import moment from 'moment';
import { DATE_FORMAT } from 'common/constants/constants';
import useSensorAuthAPI from 'common/hooks/sensors/useSensorAuthAPI';
import useTokenValidatorHandler from 'components/TokenValidator/useTokenValidatorHandler';

interface IntegrationConnectionProps {
  integration?: SensorAuthorization | null;
  sensorId: number;
}

const IntegrationConnection: React.FC<IntegrationConnectionProps> = ({
  integration = null,
  sensorId
}) => {
  const isConnected = !!integration;

  const tokenValidatorHandler = useTokenValidatorHandler({ sensorId });
  const sensorAuthAPI = useSensorAuthAPI({ sensorId });

  const onConnectClick = async () => {
    await sensorAuthAPI.create({
      token: tokenValidatorHandler.token,
      username: tokenValidatorHandler.successPayload?.username
    });
  };

  return (
    <div className='space-y-6'>
      <p className='text-sm text-muted-foreground'>
        Connect your GitHub Copilot data to unlock usage insights. A personal
        access token (PAT) with the correct scopes is required.
      </p>

      {/* Token Input Section */}
      <div>
        <label className='mb-2 block text-sm font-medium text-gray-700'>
          Token
        </label>

        <TokenValidator
          token={tokenValidatorHandler.token}
          setToken={tokenValidatorHandler.setToken}
          status={tokenValidatorHandler.status}
          loading={tokenValidatorHandler.loading}
          failurePayload={tokenValidatorHandler.failurePayload}
          disabled={isConnected}
          showMaskedToken={isConnected}
          inputClassName='w-[30rem]'
        />
        {isConnected && (
          <div className='text-sm text-muted-foreground'>
            Last updated on {moment(integration.updated_at).format(DATE_FORMAT)}
          </div>
        )}
      </div>

      {!isConnected && (
        <div>
          <LBButton
            size='lg'
            disabled={!tokenValidatorHandler.isValid}
            onClick={onConnectClick}
          >
            Connect and select organizations
          </LBButton>
        </div>
      )}
    </div>
  );
};

export default IntegrationConnection;
